import { useSelector } from 'react-redux'
import { getGiftsByDateSelector } from 'src/redux-api-bridge/cart/selectors'
import CartSectionHeaderTitle from 'src/componentsV2/Cart/components/CartSectionHeaderTitle/CartSectionHeaderTitle'
import Gift from 'src/componentsV2/Gift/Gift'
import './GiftsSection.scss'

const GiftsSection = () => {
  const gifts = useSelector(getGiftsByDateSelector)

  if (!gifts || !gifts.items || gifts.items.length === 0) {
    return null
  }

  return (
    <div className="gifts-section">
      {gifts.title?.value && (
        <div className="gifts-section__title-wrapper">
          <CartSectionHeaderTitle
            title={gifts.title.value}
            subtitle={gifts.subtitle}
          />
        </div>
      )}
      <div className="gifts-sections__gifts">
        {gifts.items.map(({ title, image, tags, quantity }) => (
          <Gift
            key={title}
            title={title}
            image={image}
            tags={tags}
            quantity={quantity}
          />
        ))}
      </div>
    </div>
  )
}

export default GiftsSection
